import { render } from "./djl_events.vue?vue&type=template&id=4602c405"
import script from "./djl_events.vue?vue&type=script&lang=js"
export * from "./djl_events.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__